import * as React from "react";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import { Outlet } from "react-router-dom";
import { PageContainer } from "@toolpad/core";
import PreventBackNavigation from "../../hooks/usePreventBackNavigation";
import HeaderSection from "./HeaderSection/HeaderSection";

const Dashboard = () => {
  const breadcrumbs = [{ title: "", path: "" }];
  return (
    <DashboardLayout>
      <PreventBackNavigation />
      <HeaderSection />
      <PageContainer
        breadcrumbs={breadcrumbs}
        title=""
        style={{
          maxWidth: "100%",
          margin: 0,
          padding: 5,
        }}
      >
        <Outlet />
      </PageContainer>
    </DashboardLayout>
  );
};

export default Dashboard;
